export default "__VITE_ASSET__46b28395__"